export const styles = {
  graphCard1: { height: "400px", overflowX: "auto", marginBottom: "20px" },
  boxStyle: { height: "calc(100vh - 100px)" },
};
